import { render, staticRenderFns } from "./AdminMastersList.vue?vue&type=template&id=28592f6e&scoped=true"
import script from "./AdminMastersList.vue?vue&type=script&lang=js"
export * from "./AdminMastersList.vue?vue&type=script&lang=js"
import style0 from "./AdminMastersList.vue?vue&type=style&index=0&id=28592f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28592f6e",
  null
  
)

export default component.exports